import {CloseOutlined} from '@ant-design/icons';
import PropTypes from 'prop-types';

const SelectedFilters = ({filters, setFilters}) => {
  const removeFilter = (type, value) => {
    setFilters(prev => {
      if (['productCategories', 'brands', 'features', 'colors'].includes(type)) {
        return {
          ...prev,
          [type]: (prev[type] || []).filter(item => item !== value),
        };
      }

      if (type === 'minPrice' || type === 'maxPrice') {
        return {...prev, [type]: ''};
      }

      return prev;
    });
  };

  return (
    <div className={'bg-white px-3 py-2 rounded flex flex-row items-center justify-between'}>
      <div className={'flex flex-wrap gap-2'}>
    
        {/* Product Category */}
        {filters.productCategories?.map(cat => (
          <div key={cat}
            className={'bg-primary-200 px-3 py-1 rounded-xl flex items-center gap-1 text-sm'}>
            {cat}
            <CloseOutlined
              className={'cursor-pointer text-xs'}
              onClick={() => removeFilter('productCategories', cat)} />
          </div>
        ))}

        {/* Brands */}
        {filters.brands?.map(brand => (
          <div
            key={brand}
            className={'bg-primary-200 px-3 py-1 rounded-xl flex items-center gap-1 text-sm'}
          >
            {brand}
            <CloseOutlined
              className={'cursor-pointer text-xs'}
              onClick={() =>
                removeFilter('brands', brand)
              }
            />
          </div>
        ))}

        {/* FEATURES */}
        {filters.features?.map(feature => (
          <div
            key={feature}
            className={'bg-primary-200 px-3 py-1 rounded-xl flex items-center gap-1 text-sm'}
          >
            {feature}
            <CloseOutlined
              className={'cursor-pointer text-xs'}
              onClick={() => removeFilter('features', feature)}
            />
          </div>
        ))}

        {/* Min Price */}
        {filters.minPrice !== '' && (
          <div className={'bg-primary-200 px-3 py-1 rounded-xl flex items-center gap-1 text-sm'}>
            Min: {filters.minPrice}
            <CloseOutlined
              className={'cursor-pointer text-xs'}
              onClick={() => removeFilter('minPrice')}
            />
          </div>
        )}

        {/* Max Price */}
        {filters.maxPrice !== '' && (
          <div className={'bg-primary-200 px-3 py-1 rounded-xl flex items-center gap-1 text-sm'}>
            Max: {filters.maxPrice}
            <CloseOutlined
              className={'cursor-pointer text-xs'}
              onClick={() => removeFilter('maxPrice')}
            />
          </div>
        )}
      </div>
    </div>
  );
};

SelectedFilters.propTypes = {
  filters: PropTypes.shape({
    productCategories: PropTypes.arrayOf(PropTypes.string),
    brands: PropTypes.arrayOf(PropTypes.string),
    features: PropTypes.arrayOf(PropTypes.string),
    colors: PropTypes.arrayOf(PropTypes.string),
    minPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    maxPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,

  setFilters: PropTypes.func.isRequired,
};

export default SelectedFilters;
